module.exports = __webpack_public_path__ + "static/media/017.058b7b3a.jpg";